// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/arrow-right-grey.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-forms-modal {
  height: 100%;
  max-height: 75vh;
  min-height: 60vh;
  display: flex;
  padding-bottom: 0 !important;
  flex-direction: column;
  width: max-content;
  max-width: 824px !important;
}
.select-forms-modal .modal-body {
  height: calc(100% - 107px);
  display: flex;
  padding-bottom: 32px;
  flex-direction: column;
  padding-bottom: 0;
}
.select-forms-modal .modal-body .select-forms-title {
  font-size: 18px;
  margin-bottom: 16px;
  color: #2d3648;
  font-weight: 600;
}
.select-forms-modal .modal-body .task-name-group {
  margin-bottom: 34px;
}
.select-forms-modal .modal-body .forms--container {
  min-height: 300px;
  height: 100%;
  display: flex;
  gap: 32px;
  align-items: stretch;
  margin-top: 10px;
}
.select-forms-modal .modal-body .forms--container .no--result {
  padding: 24px 27px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: #101828;
}
.select-forms-modal .modal-body .forms--container .forms--suggest {
  width: 100%;
  height: 100%;
  max-width: 426px;
  position: relative;
}
.select-forms-modal .modal-body .forms--container .forms--suggest .select-all-forms-checkbox {
  margin-left: 24px;
}
.select-forms-modal .modal-body .forms--container .forms--suggest .select-all-forms-checkbox .select-all-forms-label {
  color: #98a2b3;
  font-size: 16px;
  font-weight: 400;
}
.select-forms-modal .modal-body .forms--container .forms--suggest .lds-ring-wrapper {
  position: absolute !important;
  width: unset !important;
  height: unset !important;
}
.select-forms-modal .modal-body .forms--container .forms--suggest .forms--suggest__list {
  height: 384px;
  height: 100%;
  overflow: hidden auto;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background-color: #ffffff;
}
.select-forms-modal .modal-body .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox {
  min-height: 64px;
  width: 100%;
  cursor: pointer;
  margin-bottom: 0;
  padding: 14px 27px;
}
.select-forms-modal .modal-body .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox:nth-child(n+2) {
  border-top: 1px solid #dadee4;
}
.select-forms-modal .modal-body .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox .input {
  margin-top: -14px;
  margin-left: -27px;
}
.select-forms-modal .modal-body .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox .input.folder-checkbox-input {
  margin-top: 0;
  margin-left: 0;
  top: 22px;
  left: 28px;
  width: 20px;
  height: 20px;
}
.select-forms-modal .modal-body .forms--container .forms--suggest .forms--suggest__list .form-control-checkbox .label {
  display: flex;
  align-items: center;
}
.select-forms-modal .modal-body .forms--container .selected--forms {
  width: 50%;
}
.select-forms-modal .modal-body .forms--container .selected--forms .selected--forms__title {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color: var(--Secondary-On-Surface, #98a2b3);
}
.select-forms-modal .modal-body .forms--container .selected--forms .selected--forms__list {
  display: block;
  margin-top: 16px;
  height: 100%;
  overflow: hidden auto;
}
.select-forms-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  margin-right: 5px;
  gap: 0;
}
.select-forms-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item p {
  width: fit-content;
}
.select-forms-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item:hover {
  color: #7f56d9;
}
.select-forms-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item svg {
  cursor: pointer;
  margin-left: 10px;
  flex-shrink: 0;
}
.select-forms-modal .modal-body .forms--container .selected--forms .selected--forms__list .selected--forms__list__item svg:hover {
  opacity: 0.7;
}
.select-forms-modal .modal-footer {
  z-index: 2;
  width: calc(100% + 64px);
  position: initial;
  justify-content: space-around;
  height: 107px;
}
.select-forms-modal .modal-footer .btn {
  padding: 10px 50px;
}
.select-forms-modal .breadcrumbs .breadcrumbs-item {
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  color: var(--secondary-text, #667085);
}
.select-forms-modal .breadcrumbs .breadcrumbs-item::after {
  top: -4px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.select-forms-modal .library-filters {
  margin-bottom: 15px;
}
.select-forms-modal .library-filter {
  margin-top: 10px;
  margin-bottom: 0;
  gap: 32px;
}
.select-forms-modal .library-filter .status-filter {
  width: 40%;
  min-width: 250px;
}`, "",{"version":3,"sources":["webpack://./src/pages/user/export-user-submissions/SelectFormsModal/styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;AACF;AACE;EACE,0BAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;AACJ;AACI;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AACN;AAEI;EACE,mBAAA;AAAN;AAGI;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AADN;AAGM;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AADR;AAIM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAFR;AAIQ;EACE,iBAAA;AAFV;AAGU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AADZ;AAIQ;EACE,6BAAA;EACA,uBAAA;EACA,wBAAA;AAFV;AAKQ;EACE,aAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AAHV;AAKU;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAHZ;AAKY;EACE,6BAAA;AAHd;AAMY;EACE,iBAAA;EACA,kBAAA;AAJd;AAMc;EACE,aAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAJhB;AAQY;EACE,aAAA;EACA,mBAAA;AANd;AAYM;EACE,UAAA;AAVR;AAWQ;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;AATV;AAYQ;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;AAVV;AAYU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;EACA,MAAA;AAVZ;AAYY;EACE,kBAAA;AAVd;AAaY;EACE,cAAA;AAXd;AAaY;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAXd;AAYc;EACE,YAAA;AAVhB;AAmBE;EACE,UAAA;EACA,wBAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;AAjBJ;AAmBI;EACE,kBAAA;AAjBN;AAsBI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qCAAA;AApBN;AAsBM;EACE,SAAA;EACA,yDAAA;AApBR;AAyBE;EACE,mBAAA;AAvBJ;AA0BE;EACE,gBAAA;EACA,gBAAA;EACA,SAAA;AAxBJ;AA0BI;EACE,UAAA;EACA,gBAAA;AAxBN","sourcesContent":[".select-forms-modal {\n  height: 100%;\n  max-height: 75vh;\n  min-height: 60vh;\n  display: flex;\n  padding-bottom: 0 !important;\n  flex-direction: column;\n  width: max-content;\n  max-width: 824px !important;\n\n  .modal-body {\n    height: calc(100% - 107px);\n    display: flex;\n    padding-bottom: 32px;\n    flex-direction: column;\n    padding-bottom: 0;\n\n    .select-forms-title {\n      font-size: 18px;\n      margin-bottom: 16px;\n      color: #2d3648;\n      font-weight: 600;\n    }\n\n    .task-name-group {\n      margin-bottom: 34px;\n    }\n\n    .forms--container {\n      min-height: 300px;\n      height: 100%;\n      display: flex;\n      gap: 32px;\n      align-items: stretch;\n      margin-top: 10px;\n\n      .no--result {\n        padding: 24px 27px;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        color: #101828;\n      }\n\n      .forms--suggest {\n        width: 100%;\n        height: 100%;\n        max-width: 426px;\n        position: relative;\n\n        .select-all-forms-checkbox {\n          margin-left: 24px;\n          .select-all-forms-label {\n            color: #98a2b3;\n            font-size: 16px;\n            font-weight: 400;\n          }\n        }\n        .lds-ring-wrapper {\n          position: absolute !important;\n          width: unset !important;\n          height: unset !important;\n        }\n\n        .forms--suggest__list {\n          height: 384px;\n          height: 100%;\n          overflow: hidden auto;\n          border-top-left-radius: 6px;\n          border-top-right-radius: 6px;\n          background-color: #ffffff;\n\n          .form-control-checkbox {\n            min-height: 64px;\n            width: 100%;\n            cursor: pointer;\n            margin-bottom: 0;\n            padding: 14px 27px;\n\n            &:nth-child(n + 2) {\n              border-top: 1px solid #dadee4;\n            }\n\n            .input {\n              margin-top: -14px;\n              margin-left: -27px;\n\n              &.folder-checkbox-input {\n                margin-top: 0;\n                margin-left: 0;\n                top: 22px;\n                left: 28px;\n                width: 20px;\n                height: 20px;\n              }\n            }\n\n            .label {\n              display: flex;\n              align-items: center;\n            }\n          }\n        }\n      }\n\n      .selected--forms {\n        width: 50%;\n        .selected--forms__title {\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 400;\n          color: var(--Secondary-On-Surface, #98a2b3);\n        }\n\n        .selected--forms__list {\n          display: block;\n          margin-top: 16px;\n          height: 100%;\n          overflow: hidden auto;\n\n          .selected--forms__list__item {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin: 10px 0;\n            margin-right: 5px;\n            gap: 0;\n\n            p {\n              width: fit-content;\n            }\n\n            &:hover {\n              color: #7f56d9;\n            }\n            svg {\n              cursor: pointer;\n              margin-left: 10px;\n              flex-shrink: 0;\n              &:hover {\n                opacity: 0.7;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .modal-footer {\n    z-index: 2;\n    width: calc(100% + 64px);\n    position: initial;\n    justify-content: space-around;\n    height: 107px;\n\n    .btn {\n      padding: 10px 50px;\n    }\n  }\n\n  .breadcrumbs {\n    .breadcrumbs-item {\n      font-size: 16px;\n      line-height: 16px;\n      font-weight: 600;\n      color: var(--secondary-text, #667085);\n\n      &::after {\n        top: -4px;\n        background-image: url('../../../../assets/images/arrow-right-grey.svg');\n      }\n    }\n  }\n\n  .library-filters {\n    margin-bottom: 15px;\n  }\n\n  .library-filter {\n    margin-top: 10px;\n    margin-bottom: 0;\n    gap: 32px;\n\n    .status-filter {\n      width: 40%;\n      min-width: 250px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
